export const lightColors: any = {
  primary: '#004AAD',
  primary50: '#1B9742',
  primaryLight: '#E6EDF7',
  secondary: '#E11D48',
  danger: '#ED4337',
  white: '#ffffff',
  black: '#000',
  inputBorder: '#C8CDE0',
  brown50: '#E8E8E8',
  text: '#343F52',
  text50: '#A0A0A0',
  textGrey: '#4B5563',
  grey500: '#333333',
  placeholder: '#B9B9B9',
  borderColor: '#e9e9e9',
  childrenColor: '#fdfdfd',
  shadowColor: '#eff3f9',
  red: '#FE1B1B',
  red500: '#FD2100',
  red50: '#FFE9E6',
  success100: '#22C55E',
  success50: '#E9FFF1',
  yellow500: '#E2AF2C',
  yellow100: '#FEF0CD',
  boxShadow: `0 0 8px 0px #E6EDF7`,
  blue500: '#004aad',
}

export const darkColors: any = {
  primary: '#3B82F6', // Lighter blue for dark mode contrast
  primary50: '#22C55E',
  primaryLight: '#1F2937', // Dark gray/navy instead of white/light-blue
  secondary: '#F43F5E',
  danger: '#EF4444',
  white: '#111827', // The primary card/background color
  black: '#FFFFFF', // Inverted text-like black -> white
  inputBorder: '#374151',
  brown50: '#374151',
  text: '#E5E7EB', // Crisp light-grey text
  text50: '#9CA3AF',
  textGrey: '#D1D5DB',
  grey500: '#F3F4F6',
  placeholder: '#6B7280',
  borderColor: '#374151', // Dark border matching gray-700
  childrenColor: '#030712', // Very dark for main background
  shadowColor: '#000000',
  red: '#EF4444',
  red500: '#F87171',
  red50: '#450a0a',
  success100: '#34D399',
  success50: '#064e3b',
  yellow500: '#FBBF24',
  yellow100: '#713f12',
  boxShadow: `0 4px 6px -1px rgba(0, 0, 0, 0.4)`,
  blue500: '#3B82F6',
}

export const lightTheme = { colors: lightColors }
export const darkTheme = { colors: darkColors }

// Ensure backwards compatibility where `theme.colors` were statically imported
const theme = lightTheme
export default theme
